export default __webpack_public_path__ + "static/linkedin-logo-grey-a3e71ef55ae955138ea49ff40ad7fb64.svg";